<template>
  <div
    class="signup-loading"
    aria-hidden="true"
  >
    <div class="sl-logo">
      <SignupLoaderMark />
    </div>
    <div class="sl-text">{{ t('loading') }}</div>
  </div>
</template>

<script>
import { i18nMixin } from '../helpers';
import SignupLoaderMark from './SignupLoaderMark.vue';

export default {
  name: 'SubmitLoader',
  mixins: [i18nMixin],
  components: { SignupLoaderMark },
};
</script>
